import { ca } from '@cian/analytics';

/**
 * Клик на кнопку Редактировать
 */
export function trackCommentEdit() {
  ca('event', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'edit_comment',
    label: '',
  });
}
